import { CustomAsyncSelectOption } from '../types/CustomAsyncSelectOption';

type GetFilteredOptionsProps = {
  inputValue: string;
  defaultOptions: CustomAsyncSelectOption[];
  addOption?: CustomAsyncSelectOption;
};

export const getFilteredOptions = ({
  inputValue,
  defaultOptions,
  addOption,
}: GetFilteredOptionsProps): CustomAsyncSelectOption[] => {
  const filteredDefaultOptions = defaultOptions.filter(
    (option: CustomAsyncSelectOption) =>
      option.label.toLowerCase().includes(inputValue.toLowerCase())
  );

  if (filteredDefaultOptions.length > 0) {
    return [...filteredDefaultOptions, ...(addOption ? [addOption] : [])];
  }

  return [];
};
